import { ReactNode } from 'react'

interface AdminPageLayoutProps {
  children: ReactNode
  maxWidth?: 'md' | 'lg' | 'xl' | '6xl' | '7xl'
}

export default function AdminPageLayout({
  children,
  maxWidth = '7xl'
}: AdminPageLayoutProps) {
  const maxWidthClasses = {
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl'
  }

  return (
    <div className="bg-[#F5F5F5] min-h-screen p-8">
      <div className={`${maxWidthClasses[maxWidth]} mx-auto`}>{children}</div>
    </div>
  )
}
